<script>
import form from './form'

export default {
  created () {
    this.abrirModal()
  },
  methods: {
    abrirModal () {
      this.$modal.open({
        parent: this,
        component: form,
        hasModalCard: true,
        canCancel: false
      })
    }
  }
}
</script>

<template>
  <div></div>
</template>
